<div class="coro-accordion-container">
  <div class="coro-accordion" [class.coro-accordion--standalone]="block.data.standalone">
    <div [class.standard-page-width]="!block.data.standalone">
      @if (block.data.heading) {
        <div class="coro-accordion__heading" [innerHTML]="block.data.heading"></div>
      }

      @if (block.data.description) {
        <div class="coro-accordion__description" [innerHTML]="block.data.description"></div>
      }

      <mat-accordion multi>
        @for (item of block.content; track trackByFn(i, item); let i = $index) {
          @if (item.data.contactTitle) {
            <mat-expansion-panel
              [expanded]="i === 0 && block.data.autoExpand"
              (opened)="onPanelOpened(i)"
              (closed)="setState(i, false)"
              #panel>
              <mat-expansion-panel-header
                [collapsedHeight]="'auto'"
                [expandedHeight]="'auto'"
                [core-analytics]="{
                  action: [getPanelState(i), item.data.contactTitle].join(':'),
                  block,
                }">
                <mat-panel-title
                  [innerHTML]="item.data.contactTitle"
                  [attr.id]="item.data.anchorId ?? 'block--' + item.uid"></mat-panel-title>
              </mat-expansion-panel-header>
              <div
                class="{{ block.data.contactTitle }} {{ block.data.visibility }}"
                [ngClass]="{
                  container: block.data.columnsSmall === 'full' || block.data.columnsNormal === 'full',
                  'col-sm-12': block.data.columnsSmall === 'full',
                  'col-md-12': block.data.columnsNormal === 'full',
                }"
                [ngStyle]="{
                  padding: block.data.padding,
                  margin: block.data.margin,
                }">
                <div [innerHTML]="item.data.contactText"></div>
              </div>
            </mat-expansion-panel>
          }
        }
      </mat-accordion>
    </div>
  </div>
</div>
